<div class="stock-snapshots">
    <div class="bgf-page__header">
        <h1 class="bgf-page__title mb-3">
            <i class="fa-solid fa-camera"></i>
            <span>Készlet Snapshot-ok</span>
        </h1>
        <div class="bgf-page__toolbar">
            <div class="left-wrapper"></div>
            <div class="right-wrapper">
              <button 
                class="button is-primary"
                (click)="createNewSnapshot()"
                [disabled]="creating"
                [ngClass]="{'is-loading': creating}"
            ><i class="fa-solid fa-camera mr-2"></i> Snapshot készítése</button>
            </div>
        </div>
    </div>
    <div class="table-container" [ngClass]="{'bgf-loading bgf-loading--color': fetching}">
        <table mat-table matSort [dataSource]="dataSource">
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef>Időbélyeg</th>
              <td mat-cell *matCellDef="let element"> {{element?.timestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
            </ng-container>
            <ng-container matColumnDef="remove">
                <th mat-header-cell *matHeaderCellDef>Törlés</th>
                <td mat-cell *matCellDef="let element">
                  <i class="fa-solid fa-trash edit-icon " (click)="remove(element?.timestamp)"></i>
                </td>
              </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[20, 50, 100]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
</div>